
    const langs = {
      translation: {},
    }
    export default langs
    
    